import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";

export default function SideBar(props) {
	const movingHandler = props.movingHandler;
	const [menuElem, setMenuElem] = useState();
	const [menus, setMenus] = useState([
		{
			id: "clips",
			title: "선수영상조회",
			className: "nav-item",
			linkClass: "nav-link collapsed",
			ariaControls: "retrieveClips",
			ariaExpanded: "true",
			subMenus: {
				id: "retrieveClips",
				className: "collapse",
				subTitle: "선수영상조회:",
				menus: [
					{
						title: "경기조회",
						className: "collapse-item",
						link: "/clip/gameCriteria",
						dataParent: "clips",
					},
					{
						title: "조회된경기목록",
						className: "collapse-item",
						link: "/clip/gameList",
						dataParent: "clips",
					},
					{
						title: "클립영상목록",
						className: "collapse-item",
						link: "/clip/videoList",
						dataParent: "clips",
					},
				],
			},
		},
	]);

	useEffect(() => {
		let location = props.currentLocation;

		let pathname = location.pathname;

		let newMenus = [...menus];

		let findMenu = newMenus.find((menu) => {
			let subMenus = menu.subMenus.menus;
			subMenuHandler(subMenus, pathname);
			let findSubMenu = subMenus.find((subMenu) => {
				if (subMenu.link === pathname) return true;
				return false;
			});

			if (menu.id === findSubMenu.dataParent) return true;

			return false;
		});

		if (location.key === "default") {
			findMenu.ariaExpanded = "true";
		}

		openHandler(findMenu);
		setMenus(newMenus);
	}, [props.currentLocation]);

	useEffect(() => {
		let menuElement = menus.map((menu) => {
			return (
				<li className={menu.className} key={menu.id}>
					<a
						id={menu.id}
						className={menu.linkClass}
						data-toggle="collapse"
						aria-controls={menu.ariaControls}
						aria-expanded={menu.ariaExpanded}
						onClick={menuClickHandler}
					>
						<i className="fas fa-fw fa-cog"></i>
						<span>{menu.title}</span>
					</a>
					<div
						id={menu.subMenus.id}
						className={menu.subMenus.className}
						aria-labelledby="headingTwo"
						data-parent="#accordionSidebar"
						style={{zIndex:"5"}}
					>
						<div className="bg-white py-2 collapse-inner rounded">
							{/* <h6 className="collapse-header">
								{menu.subMenus.subTitle}
							</h6> */}
							{menu.subMenus.menus.map((subMenu, idx) => {
								return (
									<a
										key={menu.subMenus.id + `_` + idx}
										className={subMenu.className}
										href="#"
										onClick={(evt) => {
											subMenuClickHandler(evt);
										}}
										rel={subMenu.link}
										data-parent={subMenu.dataParent}
									>
										{subMenu.title}
									</a>
								);
							})}
						</div>
					</div>
				</li>
			);
		});

		setMenuElem(menuElement);
	}, [menus,props]);

	const menuClickHandler = (evt) => {
		evt.preventDefault();

		let target = $(evt.currentTarget);
		let targetId = target.attr("id");
		let newMenus = [...menus];

		let findMenu = newMenus.find((menu) => {
			if (menu.id === targetId) return true;
			return false;
		});
		openHandler(findMenu);
		setMenus(newMenus);
	};

	const subMenuClickHandler = (evt) => {
		evt.preventDefault();

		//이 값이 비어있을때 videoList 페이지로 갈 수 없음
		let gameInfo = props.criteria.gameInfoIds;

		let target = $(evt.currentTarget);
		let targetId = target.attr("data-parent");

		let newMenus = [...menus];
		let selectMenu = newMenus.find((menu) => {
			if (menu.id === targetId) return true;
			return false;
		});

		openHandler(selectMenu);

		let subMenus = selectMenu.subMenus.menus;
		let clickedUrl = target.attr("rel");

		if(clickedUrl == '/clip/videoList' && gameInfo.length == 0){
			//만약 클립영상목록을 선택했는데 선택된 경기가 없다면 (alert 창 띄워줌)
			if(props.useLang === "en"){
				alert("The video does not exist. Please choose the game first");
			} else {
				alert("영상이 존재하지 않습니다. 경기를 먼저 선택해주세요");
			}
		} else {
			//그렇지 않다면 (정상 동작)
			subMenuHandler(subMenus, clickedUrl);

			setMenus(newMenus);

			movingHandler(clickedUrl);
		}

	};

	function openHandler(menu) {
		let isExpanded = menu.ariaExpanded === "true" ? true : false;

		if (isExpanded) {
			menu.ariaExpanded = "false";
			menu.className = "nav-item active";
			menu.linkClass = "nav-link";
			menu.subMenus.className = "collapse show";
		} else {
			menu.ariaExpanded = "true";
			menu.className = "nav-item";
			menu.linkClass = "nav-link collapsed";
			menu.subMenus.className = "collapse";
		}
	}

	function subMenuHandler(menus, clickedUrl) {
		menus.map((menu) => {
			menu.className = "collapse-item";
			if (clickedUrl === menu.link) {
				menu.className = "collapse-item active";
			}
			return false;
		});
	}

	return (
		<ul
			className={`navbar-nav sidebar sidebar-dark accordion ${props.isToggled}`}
			id="accordionSidebar"
		>
			<div
				id="sidebarLogoArea"
				className="sidebar-brand d-flex align-items-center justify-content-center"
				style={{paddingLeft:"0px"}}
			>
				<a href="/clip/gameCriteria">
					<img
						// width="150px"
						alt="main_logo"
						src="../logo_hiball.png"
						style={{
							width:"100%"
						}}
					/>
				</a>
			</div>

			<hr className="sidebar-divider my-0" />

			<li className="nav-item">
				<a className="nav-link" href="/clip/gameCriteria">
					<i className="fas fa-fw fa-tachometer-alt"></i>
					<span>HOME</span>
				</a>
			</li>

			{/* <hr className="sidebar-divider" /> */}

			{/* <div className="sidebar-heading">선수경기영상</div> */}

			{menuElem}
			{/* <li className="nav-item">
				<a
					className="nav-link collapsed"
					href="#"
					data-toggle="collapse"
					data-target="#collapseTwo"
					aria-expanded="true"
					aria-controls="collapseTwo"
				>
					<i className="fas fa-fw fa-cog"></i>
					<span>Components</span>
				</a>
				<div
					id="collapseTwo"
					className="collapse show"
					aria-labelledby="headingTwo"
					data-parent="#accordionSidebar"
				>
					<div className="bg-white py-2 collapse-inner rounded">
						<h6 className="collapse-header">Custom Components:</h6>
						<a className="collapse-item" href="buttons.html">
							Buttons
						</a>
						<a className="collapse-item" href="cards.html">
							Cards
						</a>
					</div>
				</div>
			</li> */}
		</ul>
	);
}
